
// import React, { useState, useEffect, useCallback } from "react";
// import styles from "./dailysales.module.css";
// import { dailySalesApi } from "../../../api/home/dailySalesApi";
// import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend
// } from 'chart.js';
// import { Bar } from 'react-chartjs-2';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// const MONTHS = [
//     { label: 'January',   value: '1'  },
//     { label: 'February',  value: '2'  },
//     { label: 'March',     value: '3'  },
//     { label: 'April',     value: '4'  },
//     { label: 'May',       value: '5'  },
//     { label: 'June',      value: '6'  },
//     { label: 'July',      value: '7'  },
//     { label: 'August',    value: '8'  },
//     { label: 'September', value: '9'  },
//     { label: 'October',   value: '10' },
//     { label: 'November',  value: '11' },
//     { label: 'December',  value: '12' }
// ];

// const buildYears = () => {
//     const current = new Date().getFullYear();
//     const years = [];
//     for (let y = current; y >= 2024; y--) {
//         years.push(y.toString());
//     }
//     return years;
// };

// const DailySales = () => {
//     const years = buildYears();
//     const now   = new Date();

//     const [selectedYear,  setSelectedYear]  = useState(now.getFullYear().toString());
//     const [selectedMonth, setSelectedMonth] = useState((now.getMonth() + 1).toString());
//     const [activeFilters, setActiveFilters] = useState({});
//     const [chartData,     setChartData]     = useState(null);
//     const [userRole,      setUserRole]      = useState(null);
//     const [loading,       setLoading]       = useState(false);
//     const [error,         setError]         = useState(null);

//     // ─── Fetch ─────────────────────────────────────────────────
//     const fetchDailySalesData = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             const filtersToSend = {};
//             Object.entries(activeFilters).forEach(([key, val]) => {
//                 if (val) {
//                     const first = val.split(',')[0];
//                     if (first) filtersToSend[key] = first;
//                 }
//             });

//             const response = await dailySalesApi.getDailySalesData(
//                 selectedYear, selectedMonth, filtersToSend
//             );

//             const data   = response?.data || response;
//             const roleId = response?.roleId;

//             setUserRole(roleId);
//             prepareChartData(data);
//         } catch (err) {
//             setError('Failed to load daily sales data');
//             console.error('❌ Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchDailySalesData();
//     }, [selectedYear, selectedMonth, activeFilters]);

//     // ─── Chart ─────────────────────────────────────────────────
//     const prepareChartData = (data) => {
//         if (!data || data.length === 0) { setChartData(null); return; }

//         setChartData({
//             labels: data.map(item => item.date),
//             datasets: [{
//                 label: 'Daily Sales',
//                 data: data.map(item => item.sales),
//                 linesCount: data.map(item => item.linesCount),
//                 backgroundColor: '#9333ea',
//                 borderColor: '#9333ea',
//                 borderWidth: 1,
//                 borderRadius: 4,
//                 maxBarThickness: 40
//             }]
//         });
//     };

//     // ─── Stable filter callback ────────────────────────────────
//     const handleFiltersChange = useCallback((newFilters) => {
//         setActiveFilters(newFilters);
//     }, []);

//     const getMonthName = () =>
//         MONTHS.find(m => m.value === selectedMonth)?.label || '';

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { display: false },
//             tooltip: {
//                 callbacks: {
//                     title: (context) =>
//                         `${getMonthName()} ${context[0].label}, ${selectedYear}`,
//                     label: (context) => {
//                         const salesAmount = context.parsed.y;
//                         const linesCount  = context.dataset.linesCount[context.dataIndex];
//                         const formatted = '₹' + (salesAmount || 0).toLocaleString('en-IN', {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2
//                         });
//                         return ['Sales: ' + formatted, 'Lines: ' + linesCount];
//                     }
//                 }
//             }
//         },
//         scales: {
//             x: {
//                 grid: { display: false },
//                 title: {
//                     display: true, text: 'Date',
//                     font: { size: 12, weight: 'bold' }
//                 }
//             },
//             y: {
//                 beginAtZero: true,
//                 grid: { color: '#e5e7eb' },
//                 title: {
//                     display: true, text: 'Sales Amount (₹)',
//                     font: { size: 12, weight: 'bold' }
//                 },
//                 ticks: {
//                     callback: (value) => {
//                         if (value >= 10000000) return '₹' + (value / 10000000).toFixed(1) + 'Cr';
//                         if (value >= 100000)   return '₹' + (value / 100000).toFixed(1) + 'L';
//                         if (value >= 1000)     return '₹' + (value / 1000).toFixed(0) + 'K';
//                         return '₹' + value;
//                     }
//                 }
//             }
//         }
//     };

//     return (
//         <div className={styles.componentWrapper}>
//             <div className={styles.headerSection}>
//                 <h2 className={styles.componentTitle}>
//                     Daily Sales — {getMonthName()} {selectedYear}
//                 </h2>

//                 <div className={styles.filtersSection}>
//                     <div className={styles.filterGroup}>
//                         <label className={styles.filterLabel}>Year:</label>
//                         <select
//                             value={selectedYear}
//                             onChange={(e) => setSelectedYear(e.target.value)}
//                             className={styles.select}
//                         >
//                             {years.map(y => (
//                                 <option key={y} value={y}>{y}</option>
//                             ))}
//                         </select>
//                     </div>

//                     <div className={styles.filterGroup}>
//                         <label className={styles.filterLabel}>Month:</label>
//                         <select
//                             value={selectedMonth}
//                             onChange={(e) => setSelectedMonth(e.target.value)}
//                             className={styles.select}
//                         >
//                             {MONTHS.map(m => (
//                                 <option key={m.value} value={m.value}>{m.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//             </div>

//             {/* Same filters as SalesVsCogs, Category, DailyOrder */}
//             <SalesCogsFilters
//                 userRoleId={userRole}
//                 onFiltersChange={handleFiltersChange}
//             />

//             {error && <div className={styles.errorMessage}>{error}</div>}

//             {loading && (
//                 <div className={styles.loadingContainer}>
//                     <div className={styles.loadingSpinner} />
//                     <span>Loading chart data...</span>
//                 </div>
//             )}

//             {!loading && chartData && (
//                 <div className={styles.chartContainer}>
//                     <Bar data={chartData} options={chartOptions} />
//                 </div>
//             )}

//             {!loading && !chartData && !error && (
//                 <div className={styles.noDataMessage}>
//                     No sales data available for {getMonthName()} {selectedYear}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default DailySales;

import React, { useState, useEffect, useCallback, useRef } from "react";
import styles from "./dailysales.module.css";
import { dailySalesApi } from "../../../api/home/dailySalesApi";
import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
import * as XLSX from 'xlsx';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MONTHS = [
    { label: 'January',   value: '1'  },
    { label: 'February',  value: '2'  },
    { label: 'March',     value: '3'  },
    { label: 'April',     value: '4'  },
    { label: 'May',       value: '5'  },
    { label: 'June',      value: '6'  },
    { label: 'July',      value: '7'  },
    { label: 'August',    value: '8'  },
    { label: 'September', value: '9'  },
    { label: 'October',   value: '10' },
    { label: 'November',  value: '11' },
    { label: 'December',  value: '12' }
];

const buildYears = () => {
    const current = new Date().getFullYear();
    const years = [];
    for (let y = current; y >= 2024; y--) years.push(y.toString());
    return years;
};

const ITEMS_PER_PAGE = 15;

// ── Invoice Detail Modal ─────────────────────────────────────────────────────
const InvoiceDetailModal = ({ isOpen, onClose, date, monthName, year, filters }) => {
    const [invoices,    setInvoices]    = useState([]);
    const [loading,     setLoading]     = useState(false);
    const [error,       setError]       = useState(null);
    const [searchTerm,  setSearchTerm]  = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if (!isOpen || !date) return;
        setSearchTerm('');
        setCurrentPage(1);
        fetchInvoices();
    }, [isOpen, date]);

    const fetchInvoices = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await dailySalesApi.getDailySalesDetail(
                filters._year, filters._month, date, filters
            );
            setInvoices(data || []);
        } catch (err) {
            console.error('❌ Error fetching invoice detail:', err);
            setError('Failed to load invoices');
        } finally {
            setLoading(false);
        }
    };

    const filteredInvoices = invoices.filter(inv => {
        if (!searchTerm.trim()) return true;
        const q = searchTerm.toLowerCase();
        return (
            String(inv.invoiceNo     || '').toLowerCase().includes(q) ||
            String(inv.invoiceStatus || '').toLowerCase().includes(q) ||
            String(inv.soNo          || '').toLowerCase().includes(q) ||
            String(inv.customerName  || '').toLowerCase().includes(q) ||
            String(inv.contactPerson || '').toLowerCase().includes(q) ||
            String(inv.salesPerson   || '').toLowerCase().includes(q) ||
            String(inv.currency      || '').toLowerCase().includes(q) ||
            String(inv.trackingNo    || '').toLowerCase().includes(q) ||
            String(inv.transport     || '').toLowerCase().includes(q)
        );
    });

    const totalPages      = Math.ceil(filteredInvoices.length / ITEMS_PER_PAGE);
    const paginatedInvoices = filteredInvoices.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    useEffect(() => { setCurrentPage(1); }, [searchTerm]);

    const handleExportExcel = () => {
        const exportData = filteredInvoices.map(inv => ({
            'Invoice No':      inv.invoiceNo,
            'Invoice Date':    inv.invoiceDate,
            'Status':          inv.invoiceStatus,
            'SO Date':         inv.soDate        || 'N/A',
            'Order Time':      inv.orderTime      || 'N/A',
            'Invoice Time':    inv.invoiceTime    || 'N/A',
            'Contact Person':  inv.contactPerson  || 'N/A',
            'Due Date':        inv.dueDate        || 'N/A',
            'Customer Name':   inv.customerName,
            'Total Lines':     inv.totalLines,
            'Total Amount':    inv.totalAmount,
            'Currency':        inv.currency       || 'N/A',
            'Dispatch Date':   inv.dispatchDate   || 'N/A',
            'Tracking #':      inv.trackingNo     || 'N/A',
            'Transport':       inv.transport      || 'N/A',
            'Sales Person':    inv.salesPerson    || 'N/A',
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoices');
        XLSX.writeFile(wb, `invoices_${year}_${monthName}_${date}.xlsx`);
    };

    const formatCurrency = (n, cur) =>
        (cur && cur !== 'INR' ? cur + ' ' : '₹') +
        (n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>

                {/* Header */}
                <div className={styles.modalHeader}>
                    <div>
                        <h2 className={styles.modalTitle}>
                            Invoices — {date} {monthName} {year}
                        </h2>
                        <span className={styles.modalSubtitle}>
                            {filteredInvoices.length} invoice{filteredInvoices.length !== 1 ? 's' : ''}
                        </span>
                    </div>
                    <button className={styles.modalClose} onClick={onClose}>✕</button>
                </div>

                {/* Search + Export */}
                <div className={styles.modalToolbar}>
                    <div className={styles.modalSearchWrapper}>
                        <span className={styles.modalSearchIcon}>🔍</span>
                        <input
                            type="text"
                            placeholder="Search by invoice no, status, customer, contact, sales person, tracking, transport..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            className={styles.modalSearchInput}
                        />
                        {searchTerm && (
                            <button
                                className={styles.modalSearchClear}
                                onClick={() => setSearchTerm('')}
                            >✕</button>
                        )}
                    </div>
                    <button
                        className={styles.exportButton}
                        onClick={handleExportExcel}
                        disabled={filteredInvoices.length === 0}
                    >
                        📊 Export Excel
                    </button>
                </div>

                {/* Table */}
                <div className={styles.modalTableWrapper}>
                    {loading ? (
                        <div className={styles.modalLoading}>
                            <div className={styles.loadingSpinner} />
                            <span>Loading invoices...</span>
                        </div>
                    ) : error ? (
                        <div className={styles.modalError}>{error}</div>
                    ) : paginatedInvoices.length === 0 ? (
                        <div className={styles.modalEmpty}>
                            {searchTerm ? 'No invoices match your search' : 'No invoices for this date'}
                        </div>
                    ) : (
                        <table className={styles.modalTable}>
                            <thead>
                                <tr>
                                    <th className={styles.modalTh}>Invoice No</th>
                                    <th className={styles.modalTh}>Invoice Date</th>
                                    <th className={styles.modalTh}>Status</th>
                                    <th className={styles.modalTh}>SO Date</th>
                                    <th className={styles.modalTh}>Order Time</th>
                                    <th className={styles.modalTh}>Invoice Time</th>
                                    <th className={styles.modalTh}>Contact Person</th>
                                    <th className={styles.modalTh}>Due Date</th>
                                    <th className={styles.modalTh}>Customer Name</th>
                                    <th className={styles.modalTh}>Total Lines</th>
                                    <th className={styles.modalTh}>Total Amount</th>
                                    <th className={styles.modalTh}>Currency</th>
                                    <th className={styles.modalTh}>Dispatch Date</th>
                                    <th className={styles.modalTh}>Tracking #</th>
                                    <th className={styles.modalTh}>Transport</th>
                                    <th className={styles.modalTh}>Sales Person</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedInvoices.map((inv, i) => (
                                    <tr key={i} className={styles.modalTr}>
                                        <td className={styles.modalTd}>{inv.invoiceNo}</td>
                                        <td className={styles.modalTd}>{inv.invoiceDate}</td>
                                        <td className={styles.modalTd}>
                                            <span className={`${styles.statusBadge} ${
                                                inv.invoiceStatus === 'Open'           ? styles.statusOpen :
                                                inv.invoiceStatus === 'Partially Open' ? styles.statusPartial :
                                                inv.invoiceStatus === 'Closed'         ? styles.statusClosed :
                                                inv.invoiceStatus === 'Cancelled'      ? styles.statusCancelled :
                                                ''
                                            }`}>
                                                {inv.invoiceStatus}
                                            </span>
                                        </td>
                                        <td className={styles.modalTd}>{inv.soDate        || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.orderTime      || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.invoiceTime    || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.contactPerson  || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.dueDate        || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.customerName}</td>
                                        <td className={styles.modalTd}>{inv.totalLines}</td>
                                        <td className={styles.modalTd}>{formatCurrency(inv.totalAmount, inv.currency)}</td>
                                        <td className={styles.modalTd}>{inv.currency       || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.dispatchDate   || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.trackingNo     || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.transport      || 'N/A'}</td>
                                        <td className={styles.modalTd}>{inv.salesPerson    || 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Pagination */}
                {!loading && totalPages > 1 && (
                    <div className={styles.modalPagination}>
                        <span className={styles.paginationInfo}>
                            Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                            {Math.min(currentPage * ITEMS_PER_PAGE, filteredInvoices.length)} of {filteredInvoices.length}
                        </span>
                        <div className={styles.paginationControls}>
                            <button className={styles.paginationBtn} onClick={() => setCurrentPage(1)}           disabled={currentPage === 1}>First</button>
                            <button className={styles.paginationBtn} onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1}>Prev</button>
                            <span className={styles.pageNumber}>{currentPage} / {totalPages}</span>
                            <button className={styles.paginationBtn} onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === totalPages}>Next</button>
                            <button className={styles.paginationBtn} onClick={() => setCurrentPage(totalPages)}  disabled={currentPage === totalPages}>Last</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// ── Main DailySales component ────────────────────────────────────────────────
const DailySales = () => {
    const years    = buildYears();
    const chartRef = useRef(null);
    const now      = new Date();

    const [selectedYear,  setSelectedYear]  = useState(now.getFullYear().toString());
    const [selectedMonth, setSelectedMonth] = useState((now.getMonth() + 1).toString());
    const [activeFilters, setActiveFilters] = useState({});
    const [chartData,     setChartData]     = useState(null);
    const [userRole,      setUserRole]      = useState(null);
    const [loading,       setLoading]       = useState(false);
    const [error,         setError]         = useState(null);

    // Modal state
    const [modalOpen,  setModalOpen]  = useState(false);
    const [clickedDay, setClickedDay] = useState(null);

    // ─── Fetch chart data ──────────────────────────────────────────────────
    const fetchDailySalesData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const filtersToSend = {};
            Object.entries(activeFilters).forEach(([key, val]) => {
                if (val) {
                    const first = val.split(',')[0];
                    if (first) filtersToSend[key] = first;
                }
            });

            const response = await dailySalesApi.getDailySalesData(
                selectedYear, selectedMonth, filtersToSend
            );

            const data   = response?.data   || response;
            const roleId = response?.roleId;

            setUserRole(roleId);
            prepareChartData(data);
        } catch (err) {
            setError('Failed to load daily sales data');
            console.error('❌ Error:', err);
        } finally {
            setLoading(false);
        }
    }, [selectedYear, selectedMonth, activeFilters]);

    useEffect(() => { fetchDailySalesData(); }, [fetchDailySalesData]);

    const prepareChartData = (data) => {
        if (!data || data.length === 0) { setChartData(null); return; }
        setChartData({
            labels: data.map(item => item.date),
            datasets: [{
                label: 'Daily Sales',
                data: data.map(item => item.sales),
                linesCount: data.map(item => item.linesCount),
                backgroundColor: '#9333ea',
                hoverBackgroundColor: '#7e22ce',
                borderColor: '#9333ea',
                borderWidth: 1,
                borderRadius: 4,
                maxBarThickness: 40
            }]
        });
    };

    const handleFiltersChange = useCallback((newFilters) => {
        setActiveFilters(newFilters);
    }, []);

    const getMonthName = () => MONTHS.find(m => m.value === selectedMonth)?.label || '';

    // ─── Bar click handler ─────────────────────────────────────────────────
    const handleBarClick = useCallback((event) => {
        if (!chartRef.current) return;
        const chart    = chartRef.current;
        const elements = chart.getElementsAtEventForMode(
            event.nativeEvent, 'nearest', { intersect: true }, false
        );
        if (elements.length === 0) return;

        const index  = elements[0].index;
        const dayNum = chartData?.labels?.[index];
        if (!dayNum) return;

        setClickedDay(dayNum);
        setModalOpen(true);
    }, [chartData]);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, elements) => {
            event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    title: (context) =>
                        `${getMonthName()} ${context[0].label}, ${selectedYear}`,
                    label: (context) => {
                        const salesAmount = context.parsed.y;
                        const linesCount  = context.dataset.linesCount[context.dataIndex];
                        const formatted   = '₹' + (salesAmount || 0).toLocaleString('en-IN', {
                            minimumFractionDigits: 2, maximumFractionDigits: 2
                        });
                        return ['Sales: ' + formatted, 'Lines: ' + linesCount];
                    }
                }
            }
        },
        scales: {
            x: {
                grid: { display: false },
                title: { display: true, text: 'Date', font: { size: 12, weight: 'bold' } }
            },
            y: {
                beginAtZero: true,
                grid: { color: '#e5e7eb' },
                title: { display: true, text: 'Sales Amount (₹)', font: { size: 12, weight: 'bold' } },
                ticks: {
                    callback: (value) => {
                        if (value >= 10000000) return '₹' + (value / 10000000).toFixed(1) + 'Cr';
                        if (value >= 100000)   return '₹' + (value / 100000).toFixed(1) + 'L';
                        if (value >= 1000)     return '₹' + (value / 1000).toFixed(0) + 'K';
                        return '₹' + value;
                    }
                }
            }
        }
    };

    const modalFilters = {
        ...activeFilters,
        _year:  selectedYear,
        _month: selectedMonth,
    };

    return (
        <div className={styles.componentWrapper}>
            <div className={styles.headerSection}>
                <h2 className={styles.componentTitle}>
                    Daily Sales — {getMonthName()} {selectedYear}
                </h2>
                <div className={styles.filtersSection}>
                    <div className={styles.filterGroup}>
                        <label className={styles.filterLabel}>Year:</label>
                        <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)} className={styles.select}>
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className={styles.filterGroup}>
                        <label className={styles.filterLabel}>Month:</label>
                        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} className={styles.select}>
                            {MONTHS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <SalesCogsFilters userRoleId={userRole} onFiltersChange={handleFiltersChange} />

            {error && <div className={styles.errorMessage}>{error}</div>}

            {loading && (
                <div className={styles.loadingContainer}>
                    <div className={styles.loadingSpinner} />
                    <span>Loading chart data...</span>
                </div>
            )}

            {!loading && chartData && (
                <div className={styles.chartContainer}>
                    <Bar
                        ref={chartRef}
                        data={chartData}
                        options={chartOptions}
                        onClick={handleBarClick}
                    />
                </div>
            )}

            {!loading && !chartData && !error && (
                <div className={styles.noDataMessage}>
                    No sales data available for {getMonthName()} {selectedYear}
                </div>
            )}

            <InvoiceDetailModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                date={clickedDay}
                monthName={getMonthName()}
                year={selectedYear}
                filters={modalFilters}
            />
        </div>
    );
};

export default DailySales;